<mat-toolbar color="primary" class="printMe">
  <mat-toolbar-row class="mat-elevation-z2 main-toolbar">
    <button class="nav-toggler" mat-icon-button (click)="onToggleSidenav()">
      <mat-icon aria-label="Menu">menu</mat-icon>
    </button>
    <ul class="appNameVersion">
      <li class="logo">
        <a routerLink="/">
          <img src="/assets/img/logo_CoudPouce.png" alt="">
        </a>
      </li>
      <li><a class="app-name" routerLink="/">{{ appName }}</a></li>
    </ul>


    <ul class="menu-links" *ngIf="isAuth">
      <li *ngIf="user">
        <!-- <app-user-menu></app-user-menu> -->
        <app-user-menu [user]="user"></app-user-menu>
      </li>
    </ul>

    <ul class="version" *ngIf="!isAuth">
      <li>
        version {{appVersion}}
      </li>
    </ul>
  </mat-toolbar-row>
</mat-toolbar>